import { render, staticRenderFns } from "./tab-contracts2.vue?vue&type=template&id=54f41c51&scoped=true&"
import script from "./tab-contracts2.vue?vue&type=script&lang=js&"
export * from "./tab-contracts2.vue?vue&type=script&lang=js&"
import style0 from "./tab-contracts2.vue?vue&type=style&index=0&id=54f41c51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f41c51",
  null
  
)

export default component.exports